module.exports = __webpack_public_path__ + "static/img/cont55 (2).f482748.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont55 (2).jpg
// module id = xJ9t
// module chunks = 0